import React, {useEffect, useState} from "react";
import {Button, Form} from "antd";
import {FormItemTypeEnum} from "../../../../components2/YhFormBox/Types"
import {YhFormItemsBox} from "../../../../components2/YhFormBox"
import {useServiceItemsModel} from "../serviceItemsModel"
import useMdmModel from "../../../../model/mdmModel"
import {useNavModel} from "../../../../model/navModel";
import {DetailType} from "../../../../types/FmsEnums";
import {IServiceItemsDetail, IServiceItemsInsert, IServiceItemsUpdata, itemAttrOptions} from "../serviceItemsTypes"
import {setTitle} from "../../../../utils/utils"

const ServiceItemsDetail = () => {
    const [form] = Form.useForm();
    const {mdmCatalog, mdmBranch, mdmSourceApp, mdmOrgan, dict} = useMdmModel();
    const {selectedNavId, addNav, closeNav, getSelectedNavState, replaceNav, findNav} = useNavModel()
    const {
        addParam,
        selectedRow,
        setAddParam,
        setSelectedRow,
        setSelectedRowKeys,
        updataAddParam,
        updataEditParam,
        insertDetail,
        updataDetail
    } = useServiceItemsModel()
    const [modes, setModes] = useState<any>(getSelectedNavState("state"))
    const {id, pageParams} = modes
    const {mode, id: ids} = pageParams
    useEffect(() => {
        if (mode == DetailType.add) {
            form.setFieldsValue(addParam)
        } else if (mode == DetailType.edit || mode == DetailType.look) {
            form.setFieldsValue(selectedRow[0])
        }
    }, [addParam, selectedRow[0]])
    const onFinish = (values: IServiceItemsInsert | IServiceItemsUpdata) => {
        if (mode == DetailType.add) {
            insertDetail(values as IServiceItemsInsert).then(res => {
                if (res) close();
            })
        } else if (mode == DetailType.edit) {
            updataDetail(values as IServiceItemsDetail).then(res => {
                if (res) close();
            })
        }
    }
    // useEffect(() => {
    //     return () => {
    //         const findInsert = findNav("2-13-1")
    //         const findEdit = findNav("2-13-2")
    //         !!!findInsert && setAddParam({});
    //         !!!findEdit && setSelectedRowKeys([]) && setSelectedRow([]);
    //     }
    // }, [selectedNavId])
    const close = () => {
        replaceNav(selectedNavId, "2-13")
    }
    const items = [
        {
            type: FormItemTypeEnum.Select,
            span: 8,
            fieldLabel: "分支编码",
            labelCol: {span: 6},
            fieldName: "branch",
            options: mdmBranch
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "版本号",
            labelCol: {span: 6},
            fieldName: "ver",
            disable: true,
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "服务项目编码",
            labelCol: {span: 6},
            fieldName: "code",
            disable: mode == DetailType.edit
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "服务项目名称",
            labelCol: {span: 6},
            fieldName: "name",
            rules: [{required: true, message: '该项为必填项'}]
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "英文名称",
            labelCol: {span: 6},
            fieldName: "nameEn",
            // rules: [{ required: true, message: '该项为必填项' }]
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "工时单价",
            labelCol: {span: 6},
            fieldName: "price",
            rules: [{pattern: /^[0-9]+(.[0-9]{0,2})?$/, message: '请输入数字且可保留两位小数'}]
        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "服务工时",
            labelCol: {span: 6},
            fieldName: "workHours",
            rules: [{pattern: /^[0-9]+(.[0-9]{0,2})?$/, message: '请输入数字且可保留两位小数'}]

        },
        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "项目总金额",
            labelCol: {span: 6},
            fieldName: "amount",
            disable: true
        },
        {
            type: FormItemTypeEnum.Switch,
            span: 8,
            fieldLabel: "状态",
            labelCol: {span: 6},
            fieldName: "enable",
            valuePropName: "checked",
            checkedChildren: "启用",
            unCheckedChildren: "禁用"
        },

        {
            type: FormItemTypeEnum.Input,
            span: 8,
            fieldLabel: "品牌",
            labelCol: {span: 6},
            fieldName: "itemBrand",
            disable: false
        },
        {
            type: FormItemTypeEnum.Select,
            span: 8,
            fieldLabel: "属性",
            labelCol: {span: 6},
            fieldName: "itemAttr",
            options: itemAttrOptions
        },


        {
            type: FormItemTypeEnum.Input,
            span: 16,
            fieldLabel: "备注",
            labelCol: {span: 3},
            fieldName: "note",
        },
    ]
    const title = <div className="font-bold font-size-lg">{setTitle(mode)}服务项目</div>
    const reset = () => {
        form.resetFields()
        if (mode == DetailType.add) {
            setAddParam({
                price: 0,
                workHours: 1,
                amount: 0
            })
        } else if (mode == DetailType.edit) {
            form.setFieldsValue({code: selectedRow[0].code})
            setSelectedRow([{
                code: selectedRow[0].code,
                price: 0,
                workHours: 1,
                amount: 0
            }])
        }
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => form.submit()}
        >保存</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            hidden={mode == DetailType.look}
            onClick={() => reset()}
        >重置</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => close()}
        >取消</Button>
    </>
    return <Form
        form={form}
        onValuesChange={mode == DetailType.add ? updataAddParam : updataEditParam}
        onFinish={onFinish}
    >
        <YhFormItemsBox disabled={mode == DetailType.look} items={items} title={title} action={action}
                        IclassName="p-20"/>
    </Form>
}
export default ServiceItemsDetail
